export default __webpack_public_path__ + "static/media/dpi.8808ab40.svg";